/**
 * DefendantInfoSection - Core defendant fields for AcceptQuoteModal
 */

import { OathInput, OathSelect } from '../../../../shared/OathUI';
import { ACCEPT_QUOTE_FIELD_MAX_LENGTH } from '../../shared/requestFieldLimits';
import { STATE_OPTIONS } from '../../shared/usStates';
import { GENDER_OPTIONS } from '../../shared/countyRequiredFields';
import {
  formatPhoneNumber,
  unformatPhone,
  formatSSN,
  unformatSSN,
  formatCurrencyInput,
  unformatCurrencyInput,
} from '../../shared/formatUtils';

const DefendantInfoSection = ({ formState, dispatch, requiredFields }) => {
  const isRequired = (field) => requiredFields.includes(field);
  const set = (field) => (val) => dispatch({ type: 'SET_FIELD', field, value: val });

  return (
    <div>
      <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-3">Defendant Information</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
        <OathInput
          label="First Name"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.firstName}
          value={formState.firstName}
          onChange={set('firstName')}
          placeholder="First name"
          required={isRequired('firstName')}
        />
        <OathInput
          label="Middle Initial"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.middleInitial}
          value={formState.middleInitial}
          onChange={(val) => dispatch({ type: 'SET_FIELD', field: 'middleInitial', value: val.slice(0, 1) })}
          placeholder="M.I."
        />
        <OathInput
          label="Last Name"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.lastName}
          value={formState.lastName}
          onChange={set('lastName')}
          placeholder="Last name"
          required={isRequired('lastName')}
        />
        <OathInput
          label="Total Bond Amount"
          value={formatCurrencyInput(formState.totalBondAmount)}
          onChange={(val) => dispatch({ type: 'SET_FIELD', field: 'totalBondAmount', value: unformatCurrencyInput(val).replace(/[^0-9.]/g, '') })}
          placeholder="0.00"
          prefix="$"
          required={isRequired('totalBondAmount')}
        />
        <OathInput
          label="Date of Birth"
          type="date"
          value={formState.dateOfBirth}
          onChange={set('dateOfBirth')}
          required={isRequired('dateOfBirth')}
        />
        <OathInput
          label="Booking Number"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.bookingNumber}
          value={formState.bookingNumber}
          onChange={set('bookingNumber')}
          placeholder="Booking #"
          required={isRequired('bookingNumber')}
        />
        <OathInput
          label="Driver's License #"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.driversLicenseNumber}
          value={formState.driversLicenseNumber}
          onChange={set('driversLicenseNumber')}
          placeholder="DL number"
          required={isRequired('driversLicenseNumber')}
        />
        <OathSelect
          label="DL State"
          value={formState.driversLicenseState}
          onChange={set('driversLicenseState')}
          options={STATE_OPTIONS}
          placeholder="Select state..."
          required={isRequired('driversLicenseState')}
        />
        <OathSelect
          label="Gender"
          value={formState.gender}
          onChange={set('gender')}
          options={GENDER_OPTIONS}
          placeholder="Select..."
          required={isRequired('gender')}
        />
        <OathInput
          label="Race"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.race}
          value={formState.race}
          onChange={set('race')}
          placeholder="Race"
          required={isRequired('race')}
        />
        <OathInput
          label="Place of Birth"
          value={formState.placeOfBirth}
          onChange={set('placeOfBirth')}
          placeholder="City, State"
          required={isRequired('placeOfBirth')}
        />
        <OathInput
          label="SSN"
          value={formatSSN(formState.socialSecurityNumber)}
          onChange={(val) => dispatch({ type: 'SET_FIELD', field: 'socialSecurityNumber', value: unformatSSN(val) })}
          placeholder="123-45-6789"
          required={isRequired('socialSecurityNumber')}
        />
        <OathInput
          label="Arrest Date"
          type="date"
          value={formState.arrestDate}
          onChange={set('arrestDate')}
          required={isRequired('arrestDate')}
        />
        <OathInput
          label="Jail Phone"
          value={formatPhoneNumber(formState.jailPhoneNumber)}
          onChange={(val) => dispatch({ type: 'SET_FIELD', field: 'jailPhoneNumber', value: unformatPhone(val) })}
          placeholder="(555) 123-4567"
          required={isRequired('jailPhoneNumber')}
        />
        <OathInput
          label="Jail Info"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.jailInfo}
          value={formState.jailInfo}
          onChange={set('jailInfo')}
          placeholder="Additional jail info"
          required={isRequired('jailInfo')}
        />
      </div>
    </div>
  );
};

export default DefendantInfoSection;
